import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=292ae794&scoped=true"
import script from "./userDetails.vue?vue&type=script&lang=js"
export * from "./userDetails.vue?vue&type=script&lang=js"
import style0 from "./userDetails.vue?vue&type=style&index=0&id=292ae794&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292ae794",
  null
  
)

/* custom blocks */
import block0 from "./userDetails.vue?vue&type=custom&index=0&blockType=div&class=row%20mt-4&v-if=person.sms%20%26%26%20%24can('edit%20users')"
if (typeof block0 === 'function') block0(component)
import block1 from "./userDetails.vue?vue&type=custom&index=1&blockType=el-dialog&%3Atitle='SMS%20an%20'%20%2B%20person.fullname&%3Avisible.sync=dialogFormVisible"
if (typeof block1 === 'function') block1(component)

export default component.exports